import React from "react";
import PropTypes from "prop-types";
import ServerErrorMessage from "../../components/ServerErrorMessage";
import CategoryHeader from "../../components/CategoryHeader";
import ProductListingPage from "../../containers/ProductListingPage";
import CategoryOutOfStock from "../../containers/CategoryOutOfStock";
import CategoryAdvert from "../CategoryAdvert";

const CategoryPage = ({ categoryError, itemCount, hasFacets, ...rest }) => {
  if (categoryError) {
    return <ServerErrorMessage {...categoryError} />;
  }

  if (itemCount === 0 && !hasFacets) {
    return <CategoryOutOfStock {...rest} />;
  }

  return (
    <div>
      <CategoryHeader />
      <ProductListingPage Advert={CategoryAdvert} {...rest} />
    </div>
  );
};

CategoryPage.propTypes = {
  categoryError: PropTypes.shape({
    status: PropTypes.number
  }),
  hasFacets: PropTypes.bool.isRequired,
  itemCount: PropTypes.number.isRequired
};

CategoryPage.defaultProps = {};

export default CategoryPage;
